/**
 * Canonical client-side route paths.
 * Import from here instead of hard-coding strings so renames stay in one place.
 */

export const ROUTES = {
  VERIFY_EMAIL: '/verify-email/:token',
  /** Universal-link path used by mobile app (iOS/Android) */
  APP_VERIFY_EMAIL: '/app/verify-email/:token',
  /** Path prefix used in email links — no :token placeholder */
  APP_VERIFY_EMAIL_BASE: '/app/verify-email',
} as const;
